// 휴대전화 번호를 화면과 DB 에서 쓰는 형식(010-4333-5746)으로 맞춘다.
//
// 본인인증 업체(KCB·라온)는 하이픈 없이 01043335746 으로 준다. 그대로 두면
// 가입 폼의 연락처 칸과 저장된 값이 사람마다 다른 모양으로 섞인다 — 운영 DB 의
// 기존 번호는 하이픈이 있는 형식이다(2026-09-17 확인).
//
// ⚠️ 모르는 모양은 손대지 않고 그대로 돌려준다. 억지로 끼워 맞추면 해외번호나
//    대표번호가 엉뚱하게 잘린다.

const formatMobile = (value) => {
    if (value === null || value === undefined) return value;
    const raw = String(value).trim();
    const digits = raw.replace(/\D/g, '');

    // 휴대전화(010·011·016·017·018·019)와 안심번호(0503 등)를 가른다.
    if (/^01[016789]\d{7,8}$/.test(digits)) {
        return digits.length === 11
            ? `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`
            : `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    // 서울 지역번호는 두 자리다.
    if (/^02\d{7,8}$/.test(digits)) {
        return digits.length === 10
            ? `${digits.slice(0, 2)}-${digits.slice(2, 6)}-${digits.slice(6)}`
            : `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
    }
    // 그 밖의 지역번호·인터넷전화(031·070 등).
    if (/^0\d{9,10}$/.test(digits)) {
        return digits.length === 11
            ? `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`
            : `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return raw;
};

export default formatMobile;
